import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import LogosNotification from "utils/notification-utils";
import ProgramService from "../../../../services/programs/program-service";

interface AddLessonGroupDialogProps {
    program: any,
    lessonGroup: any,
    onClose: any,
    onRefreshData: any
};

const EditLessonGroupDialog: FC<AddLessonGroupDialogProps> = ({ program, lessonGroup, onClose, onRefreshData }) => {
    const [formValue, setFormValue] = useState<any>({ name: lessonGroup.title, sequence: lessonGroup.sequence });
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    useEffect(() => {
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ProgramService.EditLessonGroup(program.id, lessonGroup.id, values.name, values.sequence).then((res: any) => {
            onRefreshData(res.result);
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                    {
                        ({ handleSubmit, errors, touched }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Edit Group {lessonGroup.name}</ModalHeader>
                                <ModalBody pt={5}>

                                    <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                        <FormLabel htmlFor='name'>Nama Group</FormLabel>
                                        <Field
                                            as={Input}
                                            id='name'
                                            placeholder='Nama Group Lesson'
                                            name={'name'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Nama Group wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={!!(errors.sequence && touched.sequence)} mt={2}>
                                        <FormLabel htmlFor='name'>Urutan</FormLabel>
                                        <Field
                                            as={Input}
                                            id='sequence'
                                            placeholder='No Urutan'
                                            name={'sequence'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "No. Urutan wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.sequence}</FormErrorMessage>
                                    </FormControl>

                                </ModalBody>
                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Close
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Edit</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>
            </ModalContent>
        </Modal>
    );
};

export default EditLessonGroupDialog;
